// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const DefaultTokensState = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 9c0 3.314 1.12 6 2.5 6S13 12.314 13 9s-1.12-6-2.5-6S8 5.686 8 9M8 9H5M5.365 5.846h3"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.51 3H7.5C6.25 3 5 5.308 5 9s1.25 6 2.5 6h3.01M8 12.154H5.62"
    />
  </svg>
);
const ForwardRef = forwardRef(DefaultTokensState);
export default ForwardRef;
